import { Button } from "antd";
import type { ColumnsType } from "antd/es/table";
import { FormConfigType } from "../../../components/editForm";
import { langPage, langCommon, langTableColumns } from "../../../locales";

const langRecharge = langPage?.amount;
const lang = langPage?.amount?.withdrawal;

export const DEFAULT_QUERY_DATA = {
    Email: "",
    ManagerId: null,
    Status: null,
    AuditAtEnd: null,
    AuditAtStart: null,
    AuditAt: null,
    CreatedAtStart: null,
    CreatedAtEnd: null,
    CreatedAt: null,
}

export const generateQueryFormConfig = (props: any): FormConfigType => {

    return [
        {
            title: langRecharge?.email,
            type: "input",
            field: "Email",
            allowClear: true,
        },
        {
            title: langRecharge?.memberId,
            type: "input",
            field: "ManagerId",
            allowClear: true,
        },
        // {
        //     title: langRecharge?.auditAt,
        //     type: "rangePicker",
        //     field: "AuditAt",
        //     fields: ['AuditAtStart', 'AuditAtEnd'],
        //     allowClear: true,
        // },
        {
            title: langTableColumns?.CreatedAtString,
            type: "rangePicker",
            field: "CreatedAt",
            fields: ['CreatedAtStart', 'CreatedAtEnd'],
            allowClear: true,
        },
        {
            title: langCommon?.status,
            type: "select",
            field: "Status",
            options: [
                { id: 10, name: langRecharge?.status1 },
                { id: 20, name: langRecharge?.status2 },
                { id: 30, name: langRecharge?.status3 },
                { id: 40, name: langRecharge?.status4 },
            ],
            allowClear: true,
            style: {
                width: 200
            }
        }
    ];
}

export const generateTableColumns = (props: any): ColumnsType => {
    const { operationRef } = props;

    return [
        {
            title: '序号',
            dataIndex: "Index",
            render(value, record, index) {
                return index + 1
            },
        },
        {
            title: lang?.orderNo,
            dataIndex: "OrderNo",
        },
        {
            title: langRecharge?.memberId,
            dataIndex: "MemberId",
        },
        {
            title: langRecharge?.email,
            dataIndex: "Email",
        },
        {
            title: lang?.amount,
            dataIndex: "Amount",
        },
        {
            title: langRecharge?.commissionFee,
            dataIndex: "CommissionFee",
        },
        {
            title: langRecharge?.receivedAmount,
            dataIndex: "ReceivedAmount",
        },
        {
            title: '链类型',
            dataIndex: "UsdtChain",
        },
        {
            title: '提现地址',
            dataIndex: "WithdrawUsdtAddress",
        },
        {
            title: langRecharge?.status,
            dataIndex: "StatusString",
        },
        {
            title: langRecharge?.remark,
            dataIndex: "Remark",
        },
        {
            title: langTableColumns?.CreatedAtString,
            dataIndex: "CreatedAtString",
        },
        {
            title: '审核管理员',
            dataIndex: "AuditManager",
            render(value, record, index) {
                return value?.Username
            },
        },
        {
            title: langTableColumns?.operation,
            dataIndex: "ops",
            width: 80,
            fixed: "right",
            render: (_: any, row: any) => {
                return (
                    <div>
                        <Button size="small" type="link"
                            disabled={row?.Status !== 10}
                            onClick={() => operationRef?.current?.changeVisible(row, 'approve')}
                        >{row?.Status === 10 ? langCommon?.approve : langCommon?.approved}</Button>
                    </div>
                )
            }
        }
    ]
}

export const generateOperationFormConfig = (props: any): FormConfigType => {
    return [
        {
            title: langRecharge?.CheckResult,
            type: "select",
            field: "CheckResult",
            options: [
                { id: 40, name: langRecharge?.CheckResult1 },
                { id: 20, name: langRecharge?.CheckResult2 }
            ],
            rules: [{
                required: true,
                message: `${langCommon?.pleaseSelect} ${langRecharge?.CheckResult}`
            }]
        },
        {
            title: langRecharge?.remark,
            type: "input",
            extendType: "TextArea",
            field: "Remark",
            allowClear: true,
            rows: 5,
        },
    ];
}